import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../../api';
import { useFirmContext } from '../../providers/FirmProvider';

type GetIntentResponse = {
    intent: string;
};

async function getPaymentMethodSetupIntent(firmId: string): Promise<GetIntentResponse> {
    const { data } = await api.get(`/firms/${firmId}/subscription/v2/payment-method-setup-intent`);
    return data;
}

export function usePaymentMethodSetupIntent(): UseQueryResult<GetIntentResponse, unknown> {
    const { id } = useFirmContext();
    return useQuery(['payment-method-intent'], () => getPaymentMethodSetupIntent(id), {
        cacheTime: 0,
    });
}
